import styled, { css } from "styled-components";
import { Colors } from "../../commons/Colors";
import { Flex, Font } from "../../commons/Styles";


export const Container = styled.main`
  section{
    .section_head{
      line-height: 1.5;
      display: inline-block;
      span{ 
        font-size: inherit;
        font-family: inherit;
        line-height: inherit;
      }
    }

    .modal.video{
      .box{
        width: 95%;
        max-width: 1000px;
        position: relative;
        display: flex;
        align-items: center;
        > div{
          width: 100%;
          display: flex;
          iframe{
            width: 100%;
          }
        }
      }
      button{
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 50%;
        background: url(images/clear.png) no-repeat center center / 20px 20px;
        position: absolute;
        top: -14px;
        right: 0;
        transform: translateY(-100%);
      }
    }
    
    &.intro{
      .inner{
        button.contained_main{
          border: none;
          box-shadow: 0 5px 10px 0 rgba(66, 144, 94, 0.2);
        }
      }
    }

    &.how{
      padding: 0 0 150px;

      ul.step_list{
        .step_item{
          + .step_item{
            margin: 80px 0 0;
            position: relative;
            &::before{
              content: '';
              width: 40px;
              height: 40px;
              background: url(/images/next_green.png) center center / cover no-repeat;
              position: absolute;
              top: -60px;
            }
          }

          strong.step{
            border: 1px solid ${Colors.main};
            border-radius: 10px;
            background-color: ${Colors.light_green};
            display: block;
            ${Flex('', 'center', 'center')}
          }

          .right{
            flex: 1;
            border-radius: 10px;
            img:not(.youtube){
              border-radius: 10px;
              background-color: ${Colors.main};
            }
            .txt_bx{
              p.gray_9a{
                line-height: 1.5;
              }
            }
            .btn_youtube_video{
              width: 0;
              height: 75px;
              padding: 0;
              border: none;
              background-color: transparent;
              position: absolute;
              top: 50%;
              right: 50px;
              transform: translateY(-50%);
              opacity: 0;
              /* transition: all 1s; */
              img{
                width: 100%;
                height: 52px;
              }
            }
            
          }
        }
      }
    }

    &.service{
      .wrap{
        border: 1px solid ${Colors.gray_d8};
        position: relative;
      }
      strong{
        font-size: inherit;
      }
      .type, .price, .standard, .consulting{
        border-bottom: 1px solid ${Colors.gray_d8};
      }

      .type{
        background-color: #dedede;
        ${Flex('', 'center', 'center')}
      }

      .price{
        text-align: center;
        ${Flex('column', 'center', 'center')}
        background-color: white;
      }

      .standard{
        margin: 0 0 60px;
        background-color: white;
        ${Flex('column', 'center', '')}

        ~ p:not(.title_green){
          background-color: white;
          ${Flex('', 'center', 'center')}
          + p{
            border-top: 1px solid ${Colors.gray_d8};
          }
        }
      }

      .column_title{
        border-right: 1px solid ${Colors.gray_d8};
        .title_green{
          width: 100%;
          height: 60px;
          margin: -60px 0 0;
          border-bottom: 1px solid ${Colors.gray_d8};
          background-color: ${Colors.light_green};
          color: ${Colors.main};
          ${Flex('', 'center', 'center')}
          position: absolute;
          z-index: 1;
        }

        .service_item{
          ${Flex()}

          .item_ttl{
            border-top: 1px solid ${Colors.gray_d8};
            border-right: 1px solid ${Colors.gray_d8};
            text-align: center;
            ${Flex('', 'center', 'center')}
          }

          div{
            flex: 1;
            p{
              border-top: 1px solid ${Colors.gray_d8};
              ${Flex('', 'center', '')}
            }
          }
        }

      }

      .column_cont{
        position: relative;

        .column_group{
          + .column_group{
            border-left: 1px solid ${Colors.gray_d8};
          }

          .type{
            font-family: ${Font.bold};
          }
  
          .standard{
            text-align: center;
            line-height: 1.5;
            p{
              font-size: inherit;
            }
          }
        }
      }
    }

    &.video{
      .video_item{
        position: relative;
        cursor: pointer;
        img{
          &:not(.icon){
            width: 100%;
            object-fit: cover;
          }
          &.icon{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }

    &.review{
      .review_item{
        border: 1px solid ${Colors.main};
        cursor: pointer;

        .MuiRating-root{
          margin: 0 0 20px;
        }
        .contents{
          min-height: 96px;
          line-height: 1.5;
          color: ${Colors.gray_9a};

          &.ellipsis{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }

          &:not(.ellipsis){
            margin-bottom: 39px;
          }
        }

        button{
          padding: 10px 0;
          border: none;
          background-color: transparent;
        }
        
        strong{
          padding: 10px 0 0;
          span{
            padding: 0 0 0 15px;
            color: ${Colors.gray_9a};
          }
        }
      }

      .modal{
        .card{
          width: 840px;
          position: relative;
          button{
            width: 36px;
            height: 36px;
            border: none;
            border-radius: 50%;
            background: url(/images/clear.svg) no-repeat center center / 18px 18px;
            position: absolute;
          }

          .title{
            padding: 0 40px 0 0;
          }

          .cont{
            line-height: 24px;
          }
        }
      }
    }

    &.contact{
      background-color: #fcfcfc;
      ul{
        li.card{
          border-radius: 20px;
          cursor: pointer;
          transition: all .2s;
          &:hover{
            background-color: var(--main);
            color: white;
            transform: translateY(-20px);
          }


          img{
            height: 190px;
          }
          strong{
            text-align: center;
          }
        }
      }
    }
    
    .slick-slider{
      .slick-prev, .slick-next{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        &::before{
          content: '';
          width: 100%;
          height: 100%;
          background: url(images/arrow_prev.png) no-repeat center center / cover;
          position: absolute;
          top: 50%;
          left: 50%;
        }
      }

      .slick-prev{
        left: -50px;
        &::before{
          transform: translate(-50%, -50%);
        }
      }

      .slick-next{
        right: -50px;
        &::before{
          transform: translate(-50%, -50%) rotate(-180deg);
        }
      }
    }

    .modal{
      background-color: rgba(0, 0, 0, 0.75);
      inset: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      z-index: 100;
    }
  }


  @media screen and (min-width: 501px) {
    section{
      .section_head{
        font-size: 40px;
      }

      &.intro{
        margin: 0 0 150px;
        background: linear-gradient(to right, #fffcf6, #fbe6ac);
        .bg_img{
          height: 100%;
          background: url(/images/intro_banner.png) no-repeat center center / cover;
        }
        .inner{
          padding-top: 90px;
          padding-bottom: 215px;

          > strong{
            &.sub_text{
              margin-bottom: 20px;
              padding-left: 12px;
              font-size: 22px;
            }
            &.extra{
              font-size: 70px;
              + .extra{
                margin-top: 10px;
              }
            }
          }

          > div{
            margin: 36px 0 105px;
            .extra{
              font-size: 30px;
              &.green{
                margin: 0 5px 0 10px;
              }
            }
            .gray_9a{ font-size: 18px; }
          }

          .mobile_banner_img{
            display: none;
          }

          button.contained_main{
            padding: 20px 30px;
            border-radius: 40px;
            strong{
              font-size: 20px;
            }
          }
        }
      }

      &.how{
        .section_head{
          margin: 0 0 60px;
        }

        ul.step_list{
          .step_item{
            ${Flex()}
            + .step_item{
              &::before{
                left: 80px;
                transform: rotate(90deg);
              }
            }

            strong.step{
              width: 200px;
              margin: 0 60px 0 0;
              font-size: 22px;
            }

            .right{
              height: 120px;
              ${Flex('', 'center')}
              transition: all .5s;
              position: relative;
              /* *{
                transition: all .5s;
              } */
              
              .img_bx{
                width: 120px;
                background-color: ${Colors.main};
                border-radius: 10px;
                transition: all .5s;
                img{
                  width: 120px;
                  height: 120px;
                  padding: 24px;
                }
              }
              .txt_bx{
                flex: 1;
                ${Flex('column', '', 'center')}
                position: absolute;
                top: 50%;
                left: 150px;
                transform: translateY(-50%);
                *{
                  transition: all .5s;
                }
                strong.title{
                  margin: 0 0 13px;
                  font-size: 22px;
                }
                p.gray_9a{
                  font-size: 20px;
                }
              }

              &:hover{
                .img_bx{
                  width: 100%;
                }
                strong, p{
                  color: white;
                  cursor: default;
                }
                .btn_youtube_video{
                  width: 75px;
                  opacity: 1;
                  transition: opacity .5s;
                  transition-delay: .3s;
                }
              }
            }

            ul{
              flex: 1;
              li{
                + li{
                  margin: 30px 0 0;
                }
              }
            }
          }
        }
      }
      
      &.service{
        padding: 0 0 150px;

        .type{
          height: 80px;
          font-size: 20px;
        }

        .price{
          height: 144px;
        }

        .standard{
          height: 204px;
          padding: 30px 0;

          ~ p:not(.title_green){
            height: 80px;
          }
        }


        .column_title{
          width: 285px;
          .price, .standard{
            font-size: 20px;
          }

          .title_green{
            font-size: 16px;
          }

          .service_item{
            font-size: 16px;
            .item_ttl{
              width: 136px;
              padding: 0 30px;
              font-size: inherit;
            }
            div p{
              height: 80px;
              padding: 0 20px;
              br{
                display: none;
              }
            }
          }
        }
        
        .column_cont{
          .column_group{
            flex: 1;

            div.price{
              p{
                &:not(.gray_9a){
                  font-size: 20px;
                }
                &.gray_9a{
                  margin: 10px 0 0;
                  font-size: 16px;
                }
              }
            }
            p.price{
              font-size: 20px;
            }

            .standard{
              font-size: 16px;
              ~ p{
                font-size: 18px;
              }
            }
          }
        }
      }

      &.video{
        padding: 0 0 100px;
        .video_item{
          height: 302px;
          img{
            &:not(.icon){
              height: 300px;
              padding: 0 10px;
              border-radius: 20px;
            }
            &.icon{
              width: 80px;
              height: 56px;
            }
          }
        }
      }

      &.review{
        padding: 0 0 150px;
        .slick-slide{
          padding: 0 10px;
        }
        .review_item{
          padding: 40px 30px;
          .contents{
            font-size: 16px;
          }

          button{
            font-size: 16px;
          }

          strong{
            font-size: 18px;
          }
        }

        .card{
          padding: 40px;
          button{
            top: 32px;
            right: 32px;
          }

          .title{
            margin: 0 0 10px;
            font-size: 30px;
          }

          .MuiRating-root{
            margin: 30px 0;
          }

          .cont{
            font-size: 18px;
          }
        }
      }

      &.contact{
        padding: 150px 0 100px;
        ul{
          margin: 90px 0 0;
          li.card{
            padding: 40px 50px 50px;
            + li{
              margin-left: 20px;
            }
            img{
              margin: 0 auto 80px;
            }
            strong{
              font-size: 24px;
            }
          }
        }
      }

      &.notice{
        padding: 150px 0 0;
      } 

      &.faq{
        padding: 150px 0 180px;
        .section_head{
          margin: 0 0 70px;
        }
      }

      .slick-slider{
        .slick-list{
          margin: 0 -10px;
        }
        .slick-prev, .slick-next{
          &::before{
            width: 100%;
            height: 100%;
          }
        }
      }

      .modal{
        padding: 200px;
      }
    }
  }

  @media (max-width: 500px) {
    section{
      .section_head{
        font-size: 24px;
      }

      &.intro{
        margin: 0 0 50px;
        background: linear-gradient(to bottom, #fffcf6, #fbe6ac);
        .inner{
          padding-top: 95px;
          padding-bottom: 75px;

          > strong{
            &.sub_text{
              margin-bottom: 18px;
              padding-left: 8px;
            }
            &.extra{
              font-size: 40px;
              + .extra{
                margin-top: 8px;
              }
            }
          }

          > div{
            margin: 24px 0 10px;
            .extra{
              font-size: 22px;
              &.green{
                margin: 0 5px;
              }
            }
            .gray_9a{ font-size: 13px; }
          }

          .mobile_banner_img{
            width: 100%;
          }

          button.contained_main{
            width: 160px;
            height: 45px;
            margin: 10px auto 30px;
            border-radius: 22.5px;
            strong{
              font-size: 16px;
            }
          }
        }
      }

      &.how{
        .section_head{
          margin: 0 0 40px;
        }
        
        ul.step_list{
          .step_item{
            ${Flex('column')}
            + .step_item{
              &::before{
                left: 50%;
                transform: translate(-50%, 0) rotate(90deg);
              }
            }

            strong.step{
              height: 46px;
              font-size: 16px;
            }

            img{
              width: 80px;
              height: 80px;
              margin: 30px auto;
              padding: 16px;
            }

            .txt_bx{
              ${Flex('column', 'center', '')}
              strong.title{
                margin: 0 0 20px;
                font-size: 18px;
              }
              p.gray_9a{
                font-size: 16px;
              }
            }
          }
        }
      }

      &.service{
        padding: 0 0 80px;

        .type{
          height: 60px;
        }

        .price{
          height: 100px;
        }

        .standard{
          height: 158px;

          ~ p:not(.title_green){
            height: 66px;
          }
        }

        
        .column_title{
          width: 166px;
          .type{
            font-size: 18px;
          }
          .price, .standard{
            font-size: 16px;
          }
          .standard{
            padding: 25px 0;
          }
          .service_item{
            .item_ttl{
              width: 94px;
              padding: 0 14px;
            }
            div p{
              height: 66px;
              padding: 0 14px;
              font-size: 12px;
              text-align: center;
              ${Flex('', 'center', 'center')}
            }
          }
        }

        .column_cont{
          overflow: hidden;

          .type{
            font-size: 16px;
          }

          .standard{
            padding: 15px 10px;
            ~ p{
              font-size: 16px;

            }
          }

          .arrow_btn_group{
            width: 100%;
            height: 60px;
            padding: 0 4px;
            ${Flex('', 'center', 'space-between')}
            position: absolute;
            z-index: 1;

            button{
              width: 36px;
              height: 36px;
              border: none;

              &.btn_prev{
                background: url(images/ic_prev.svg) no-repeat center center / 24px 24px;
                &:disabled{
                  background: url(images/arrow_left_gray.svg) no-repeat center center / 24px 24px;
                }
              }

              &.btn_next{
                background: url(images/ic_next.svg) no-repeat center center / 24px 24px;
                &:disabled{
                  background: url(images/arrow_left_gray.svg) no-repeat center center / 24px 24px;
                  transform: rotate(180deg);
                }
              }
            }
          }

          .cont_wrap{
            width: 300%;

            .column_group{
              width: calc(100% * 1/3);
              min-width: calc(100% * 1/3);

              div.price{
                p{
                  &:not(.gray_9a){
                    font-size: 16px;
                  }
                  &.gray_9a{
                    margin: 5px 0 0;
                    font-size: 13px;
                  }
                }
              }
              p.price{
                font-size: 16px;
              }
            }
          }
        }
      }

      &.video{
        padding: 0 0 80px;
        
        .video_item{
          height: 162px;
          img{
            &:not(.icon){
              border-radius: 10px;
            }
            &.icon{
              width: 43px;
              height: 30px;
            }
          }
        }
      }

      &.review{
        padding: 0 0 80px;
        .review_item{
          padding: 20px;

          strong{
            font-size: 16px;
          }
        }

        .modal{
          .card{
            max-height: 100%;
            padding: 30px 20px;
            overflow: auto;

            button{
              top: 22px;
              right: 12px;
            }

            .title{
              margin: 0 0 8px;
              font-size: 20px;
            }

            .MuiRating-root{
              margin: 20px 0 14px;
            }

            .cont{
              font-size: 16px;
            }
          }
        }
      }

      &.contact{
        padding: 100px 0 50px;
        ul{
          margin: 50px 0 0;
          flex-direction: column;
          li.card{
            padding: 40px;
            + li{
              margin-top: 30px;
            }
            img{
              margin: 0 auto 50px;
            }
            strong{
              font-size: 20px;
            }
          }
        }
      }

      &.notice{
        padding: 80px 0 0;
      } 

      &.faq{
        padding: 100px 0 80px;
        .section_head{
          margin: 0 0 24px;
        }
      }

      .slick-slider{
        width: calc(100% - 60px);
        margin: 0 auto;
        .slick-prev, .slick-next{
          &::before{
            width: 24px;
            height: 24px;
          }
        }
      }

      .modal{
        padding: 40px 20px;
      }
    }
  }
`